export const contactAPIEndpoint =
  "https://ob255flso1.execute-api.ap-southeast-1.amazonaws.com/production/sendMail";



// WEBPACK FOOTER //
// ./src/config.js